import createDOMPurify from 'dompurify';

// Assainissement du HTML des champs e-commerce (ecom_summary, ecom_description).
//
// Ces champs sont du HTML saisi dans l'éditeur riche, mais rien n'oblige à passer par lui :
// quiconque peut modifier un produit peut poster directement à l'API un contenu arbitraire,
// qui serait exécuté chez tout utilisateur ouvrant la fiche. Le HTML est donc assaini partout
// où il entre (génération IA), où il sort (sauvegarde) et surtout où il est rendu (affichage).
//
// La liste blanche est celle de ce que l'éditeur sait produire, et rien d'autre : pas
// d'iframe, pas d'attribut `style`, pas de `class`, et des adresses en http(s) uniquement.
const BALISES = [
    'p', 'br', 'h2', 'h3', 'h4',
    'strong', 'em', 'u', 's',
    'ul', 'ol', 'li',
    'a', 'blockquote', 'pre', 'span', 'img',
];
const ATTRIBUTS = ['href', 'src', 'alt', 'target', 'rel'];
const ADRESSE_HTTP = /^https?:\/\//i;

// Instance dédiée : les crochets de DOMPurify sont globaux à une instance, et ceux posés ici
// ne doivent pas changer le comportement d'un autre usage de la bibliothèque dans l'application.
const purify = createDOMPurify(window);

purify.addHook('afterSanitizeAttributes', (noeud) => {
    // DOMPurify tolère de lui-même les adresses `data:` sur les images, quelle que soit
    // l'expression d'adresses autorisées. On retire donc ici tout ce qui n'est pas http(s).
    ['href', 'src'].forEach((attribut) => {
        if (noeud.hasAttribute && noeud.hasAttribute(attribut) && !ADRESSE_HTTP.test(noeud.getAttribute(attribut).trim())) {
            noeud.removeAttribute(attribut);
        }
    });
    // Un lien ouvert dans un nouvel onglet ne doit pas pouvoir piloter la page d'origine.
    if (noeud.tagName === 'A' && noeud.getAttribute('target') === '_blank') {
        noeud.setAttribute('rel', 'noopener noreferrer');
    }
});

export function sanitizeEcomHtml(html) {
    if (!html || typeof html !== 'string') return '';
    return purify.sanitize(html, {
        ALLOWED_TAGS: BALISES,
        ALLOWED_ATTR: ATTRIBUTS,
        ALLOWED_URI_REGEXP: ADRESSE_HTTP,
        // L'expression d'adresses s'applique à tout attribut qui n'est pas déclaré « sans
        // adresse » : sans cette ligne, target="_blank" et rel seraient retirés des liens.
        ADD_URI_SAFE_ATTR: ['target', 'rel'],
        ALLOW_DATA_ATTR: false,
        ALLOW_ARIA_ATTR: false,
    });
}
